import React, { useEffect } from 'react';
import { UIView, RawParams, StateDeclaration, useCurrentStateAndParams } from '@uirouter/react';
import { ErrorBoundary } from 'react-error-boundary';
import { ngDelegate } from '../services/ng.delegate';

// stop inifinite error loops
let retryAttempts = 0;

const ErrBoundary = (): JSX.Element => {
    // init
    useEffect(() => {
        retryAttempts = 0;
        ngDelegate.load();

        // destroy
        return (): void => {
            ngDelegate.unload();
            console.log('REACTERR: unload');
        };
    }, []);

    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => {}}
        >
            <div>
                <UIView />
            </div>
        </ErrorBoundary>
    );
};

type ErrorFallbackProps = {
    error: Error;
    resetErrorBoundary: () => void;
};

const ErrorFallback = ({ error, resetErrorBoundary }: ErrorFallbackProps): JSX.Element => {
    const route: { state: StateDeclaration; params: RawParams } = useCurrentStateAndParams();
    error = error || {};

    let routeName: string = '';
    if (!!route && !!route.state) {
        routeName = route.state.name || '';
    }

    // send to angular
    console.log('REACTERR: err fallback: ' + error.message);
    ngDelegate.error(error.message, routeName, '', 'Error Name: ' + error.name);

    // reset child error state
    retryAttempts++;
    if (retryAttempts < 3) {
        resetErrorBoundary();
    }

    return (
        <div role="alert">
            <p>&nbsp;</p>
        </div>
    );
};

export default ErrBoundary;
